import { OccurrenceOccupancy } from "../models/OccurrenceOccupancy";

/** The fullest date (most places taken), the earliest one on a tie; null for no dates. */
export const fullestOccupancy = (dates: OccurrenceOccupancy[]): OccurrenceOccupancy | null =>
  dates.reduce<OccurrenceOccupancy | null>(
    (best, current) =>
      best === null ||
      current.occupied > best.occupied ||
      (current.occupied === best.occupied && current.date < best.date)
        ? current
        : best,
    null,
  );

/** The viewer's local calendar day (YYYY-MM-DD) a number of days from today. */
export const isoDayFromToday = (days: number, now: Date = new Date()): string => {
  const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
  const pad = (n: number): string => String(n).padStart(2, "0");
  return `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`;
};
